import { types as api } from '@mesa-labs/mesa-api';

export const NoteTypeOptions = [
  { label: 'General', value: api.VendorNoteType.GENERAL },
  { label: 'Sales', value: api.VendorNoteType.SALES },
  { label: 'Underwriting', value: api.VendorNoteType.UNDERWRITING },
];

// mesa-ui StatusLabel color for a Note's type tag. Underwriting uses `in_review`: the `pending` colors without the
// icon StatusLabel adds to `pending`.
export const noteTypeStatusColorKey = (noteType: api.VendorNoteType): string => {
  switch (noteType) {
    case api.VendorNoteType.SALES:
      return 'recommended';
    case api.VendorNoteType.UNDERWRITING:
      return 'in_review';
    default:
      return 'neutral';
  }
};

export const noteTypeLabel = (noteType: api.VendorNoteType): string => (
  NoteTypeOptions.find((option) => option.value === noteType)?.label ?? noteType
);
